// extracted by mini-css-extract-plugin
module.exports = {"background":"styles-module__background___3u8ry","image":"styles-module__image___2h0Xm","darker":"styles-module__darker___19aq9"};